import _ from 'lodash';

import {
    REDIRECTING_TO_SIGNUP,
    SET_IMPERSONATING_STATE_KEY,
    SET_SITE_CONTEXT_ERROR_DATA,
    SET_SITE_CONTEXT_READY_DATA
} from './IwSiteContext.actions';
import { mergeStates } from '../iwProvider/StoreHelper';

const initialState = {
    ready: false,
    state_key: null,
    impersonating: false,
    impersonatingStateKey: null,
    errorCode: null,
    errorDetail: null,
    redirectingToSignup: false,
    isAccessUser: false,
    loggedInUserType: null,
    locale: null,
    openBankingBanks: [],
    truelayerBanks: [],
    is_iwocapay_seller: false
};

// eslint-disable-next-line import/no-default-export
export default function (state = mergeStates(initialState), action = {}) {
    switch (action.type) {
        case SET_SITE_CONTEXT_READY_DATA:
            return mergeStates(state, {
                ...action.data,
                ready: true
            });

        case REDIRECTING_TO_SIGNUP:
            return mergeStates(state, {
                redirectingToSignup: true
            });

        case SET_SITE_CONTEXT_ERROR_DATA:
            return mergeStates(state, {
                errorCode: _.get(action, 'data.errors[0].code', null),
                errorDetail: _.get(action, 'data.errors[0].detail', null)
            });

        case SET_IMPERSONATING_STATE_KEY:
            return mergeStates(state, {
                impersonating:
                    !!action.impersonatingStateKey &&
                    action.loggedInUserType === 'staff',
                impersonatingStateKey: action.impersonatingStateKey
            });

        default:
            return state;
    }
}
